import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper.ts";

export enum EAppointmentSlotState {
  UNAVAILABLE = "UNAVAILABLE",
  AVAILABLE = "AVAILABLE",
  AVAILABLE_3_STARS = "AVAILABLE_3_STARS",
  AVAILABLE_2_STARS = "AVAILABLE_2_STARS",
  AVAILABLE_1_STARS = "AVAILABLE_1_STARS",
  AVAILABLE_BEST = "AVAILABLE_BEST",
}

export const appointmentSearchErrorSchema = z.object({
  providerName: z.string(),
  reason: z.string(),
});

export const appointmentSearchAvailabilitySlotSchema = z.object({
  slotId: z.any().nullable(),
  state: z.nativeEnum(EAppointmentSlotState),

  startDate: branded.localeDateTime,
  endDate: branded.localeDateTime,
  serviceProviderId: z.number(),
  serviceProviderName: z.string().nullable(),
  isTooClose: z.boolean(),
});

export const appointmentSearchAvailabilitySchema = z.object({
  date: z.coerce.date(),
  slots: z.array(appointmentSearchAvailabilitySlotSchema),
});

export const appointmentSearchDtoSchema = z.object({
  totalSlots: z.number(),
  flexibleAppointmentAvailable: z.boolean(),
  errors: z.array(appointmentSearchErrorSchema),
  availabilities: z.array(appointmentSearchAvailabilitySchema),
});

export type TAppointmentSearchError = z.infer<typeof appointmentSearchErrorSchema>;
export type TAppointmentSearchAvailabilitySlot = z.infer<typeof appointmentSearchAvailabilitySlotSchema>;
export type TAppointmentSearchAvailability = z.infer<typeof appointmentSearchAvailabilitySchema>;
export type TAppointmentSearchDto = z.infer<typeof appointmentSearchDtoSchema>;
